(function () {
  "use strict";

  var ROOT_SELECTOR = "[data-jpt-sticky-cart]";

  function initStickyCart(root) {
    if (!root || root.dataset.jptStickyInitialized === "true") {
      return;
    }

    var section = root.closest(".shopify-section");

    var mainAddToCart = section
      ? section.querySelector(".main-cart-submit")
      : document.querySelector(".main-cart-submit");

    var stickyButton = root.querySelector(
      "[data-jpt-sticky-cart-button]"
    );

    var stickyShell = root.querySelector(
      ".jpt-sticky-cart-shell"
    );

    var benefitMessages = Array.prototype.slice.call(
      root.querySelectorAll("[data-jpt-benefit-message]")
    );

    if (!mainAddToCart || !stickyButton || !stickyShell) {
      return;
    }

    root.dataset.jptStickyInitialized = "true";

    var footerNear = false;
    var isVisible = false;

    var benefitIndex = 0;
    var benefitTimer = null;
    var benefitTransitionTimer = null;

    var whatsappRetryTimers = [];

    var reducedMotion =
      window.matchMedia &&
      window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      ).matches;

    var resizeObserver = null;
    var footerObserver = null;

    /* =========================================
       BENEFIT ROTATOR
       ========================================= */

    function resetBenefits() {
      if (benefitTransitionTimer) {
        window.clearTimeout(benefitTransitionTimer);
        benefitTransitionTimer = null;
      }

      benefitIndex = 0;

      benefitMessages.forEach(function (message, index) {
        message.classList.remove(
          "is-active",
          "is-leaving"
        );

        if (index === 0) {
          message.classList.add("is-active");

          message.setAttribute(
            "aria-hidden",
            "false"
          );
        } else {
          message.setAttribute(
            "aria-hidden",
            "true"
          );
        }
      });
    }

    function nextBenefit() {
      if (benefitMessages.length < 2) {
        return;
      }

      var current =
        benefitMessages[benefitIndex];

      var nextIndex =
        (benefitIndex + 1) %
        benefitMessages.length;

      var next =
        benefitMessages[nextIndex];

      current.classList.remove("is-active");

      current.classList.add("is-leaving");

      current.setAttribute(
        "aria-hidden",
        "true"
      );

      next.classList.remove("is-leaving");

      next.classList.add("is-active");

      next.setAttribute(
        "aria-hidden",
        "false"
      );

      benefitIndex = nextIndex;

      if (benefitTransitionTimer) {
        window.clearTimeout(
          benefitTransitionTimer
        );
      }

      benefitTransitionTimer =
        window.setTimeout(function () {
          current.classList.remove(
            "is-leaving"
          );
        }, 280);
    }

    function startBenefitRotation() {
      if (
        reducedMotion ||
        benefitMessages.length < 2 ||
        benefitTimer
      ) {
        return;
      }

      benefitTimer =
        window.setInterval(
          nextBenefit,
          3500
        );
    }

    function stopBenefitRotation(reset) {
      if (benefitTimer) {
        window.clearInterval(
          benefitTimer
        );

        benefitTimer = null;
      }

      if (reset) {
        resetBenefits();
      }
    }

    resetBenefits();

    /* =========================================
       STICKY BAR HEIGHT
       ========================================= */

    function getStickyHeight() {
      return Math.max(
        0,
        Math.ceil(
          stickyShell
            .getBoundingClientRect()
            .height
        )
      );
    }

    function updateStickyHeight() {
      var height =
        getStickyHeight();

      document.documentElement
        .style
        .setProperty(
          "--jpt-sticky-cart-height",
          height + "px"
        );

      /*
        If sticky height changes while visible,
        realign WhatsApp safely.
      */
      if (isVisible) {
        positionWhatsapp();
      }
    }

    if ("ResizeObserver" in window) {
      resizeObserver =
        new ResizeObserver(
          updateStickyHeight
        );

      resizeObserver.observe(
        stickyShell
      );
    }

    /* =========================================
       WHATSAPP DETECTION + POSITIONING
       ========================================= */

    var whatsappState = {
      host: null,
      icon: null,

      originalBottom: "",
      originalBottomPriority: "",

      baseBottom: null,

      originalScale: "",
      originalScalePriority: "",

      originalTransformOrigin: "",
      originalTransformOriginPriority: ""
    };

    function isVisibleElement(element) {
      if (!element) {
        return false;
      }

      var style =
        window.getComputedStyle(element);

      var rect =
        element.getBoundingClientRect();

      return (
        style.display !== "none" &&
        style.visibility !== "hidden" &&
        rect.width > 0 &&
        rect.height > 0
      );
    }

    function getFixedAncestor(element) {
      var current = element;
      var limit = 0;

      while (
        current &&
        current !== document.body &&
        limit < 12
      ) {
        var style =
          window.getComputedStyle(current);

        if (
          style.position === "fixed"
        ) {
          return current;
        }

        current =
          current.parentElement;

        limit++;
      }

      return null;
    }

    function findWhatsappWidget() {
      var selectors = [
        'a[href*="wa.me"]',
        'a[href*="api.whatsapp.com"]',
        'a[href*="whatsapp.com/send"]',
        '[aria-label*="whatsapp" i]',
        '[title*="whatsapp" i]'
      ];

      var candidates =
        document.querySelectorAll(
          selectors.join(",")
        );

      for (
        var i = 0;
        i < candidates.length;
        i++
      ) {
        var candidate =
          candidates[i];

        if (
          !isVisibleElement(candidate)
        ) {
          continue;
        }

        var fixedHost =
          getFixedAncestor(candidate);

        if (!fixedHost) {
          continue;
        }

        var computed =
          window.getComputedStyle(
            fixedHost
          );

        var parsedBottom =
          parseFloat(
            computed.bottom
          );

        if (
          computed.bottom === "auto" ||
          Number.isNaN(parsedBottom)
        ) {
          continue;
        }

        return {
          host: fixedHost,
          icon: candidate,
          bottom: parsedBottom
        };
      }

      return null;
    }

    function rememberWhatsappState(found) {
      if (
        whatsappState.host ||
        !found ||
        !found.host
      ) {
        return;
      }

      whatsappState.host =
        found.host;

      whatsappState.icon =
        found.icon || found.host;

      whatsappState.baseBottom =
        Number.isNaN(found.bottom)
          ? 20
          : found.bottom;

      whatsappState.originalBottom =
        found.host.style
          .getPropertyValue(
            "bottom"
          );

      whatsappState.originalBottomPriority =
        found.host.style
          .getPropertyPriority(
            "bottom"
          );

      if (whatsappState.icon) {
        whatsappState.originalScale =
          whatsappState.icon.style
            .getPropertyValue(
              "scale"
            );

        whatsappState.originalScalePriority =
          whatsappState.icon.style
            .getPropertyPriority(
              "scale"
            );

        whatsappState.originalTransformOrigin =
          whatsappState.icon.style
            .getPropertyValue(
              "transform-origin"
            );

        whatsappState.originalTransformOriginPriority =
          whatsappState.icon.style
            .getPropertyPriority(
              "transform-origin"
            );
      }
    }

    function enlargeWhatsappIcon() {
      var icon =
        whatsappState.icon;

      if (!icon) {
        return;
      }

      /*
        1.12 = 12% larger.
      */
      icon.style.setProperty(
        "scale",
        "1.12",
        "important"
      );

      icon.style.setProperty(
        "transform-origin",
        "bottom right",
        "important"
      );
    }

    function positionWhatsapp() {
      /*
        Delayed retries may execute after
        sticky has already hidden at footer.

        Never reposition WhatsApp when
        sticky is not visible.
      */
      if (!isVisible) {
        return;
      }

      if (!whatsappState.host) {
        var found =
          findWhatsappWidget();

        if (!found) {
          return;
        }

        rememberWhatsappState(found);
      }

      var host =
        whatsappState.host;

      if (!host) {
        return;
      }

      enlargeWhatsappIcon();

      /* =====================================
         PRODUCT WITH FLOATING VIDEO
         ===================================== */

      var floatingVideo =
        document.querySelector(
          ".jpt-floating-video"
        );

      if (
        floatingVideo &&
        isVisibleElement(floatingVideo)
      ) {
        var videoRect =
          floatingVideo
            .getBoundingClientRect();

        /*
          Align WhatsApp bottom exactly
          with floating video's bottom.
        */
        var videoBottom =
          Math.max(
            0,
            window.innerHeight -
              videoRect.bottom
          );

        host.style.setProperty(
          "bottom",
          videoBottom + "px",
          "important"
        );

        return;
      }

      /* =====================================
         PRODUCT WITHOUT FLOATING VIDEO
         ===================================== */

      /*
        Lift WhatsApp only when the sticky cart bar would actually
        sit on top of it (phones and narrow tablets, where the bar
        spans the screen). The lift uses the same formula as the
        floating video, so both always share one baseline.

        On wide screens the bar is centered and never reaches the
        icon, so WhatsApp stays at its normal resting position.
      */

      var shellRect =
        stickyShell.getBoundingClientRect();

      var hostRect =
        host.getBoundingClientRect();

      var barOverlapsIcon =
        shellRect.right > hostRect.left - 8 &&
        shellRect.left < hostRect.right + 8;

      if (barOverlapsIcon) {
        host.style.setProperty(
          "bottom",
          "calc(var(--jpt-sticky-cart-height, 86px) + 26px + env(safe-area-inset-bottom))",
          "important"
        );

        return;
      }

      if (whatsappState.originalBottom) {
        host.style.setProperty(
          "bottom",
          whatsappState.originalBottom,
          whatsappState.originalBottomPriority
        );
      } else {
        host.style.removeProperty("bottom");
      }
    }

    function clearWhatsappRetryTimers() {
      whatsappRetryTimers.forEach(
        function (timer) {
          window.clearTimeout(timer);
        }
      );

      whatsappRetryTimers = [];
    }

    function scheduleWhatsappPositioning() {
      clearWhatsappRetryTimers();

      /*
        Try immediately.
      */
      positionWhatsapp();

      /*
        WhatsApp widgets sometimes load
        slightly after the page.
      */
      [500, 1500].forEach(
        function (delay) {
          whatsappRetryTimers.push(
            window.setTimeout(
              positionWhatsapp,
              delay
            )
          );
        }
      );
    }

    function restoreWhatsapp() {
      clearWhatsappRetryTimers();

      if (
        !whatsappState.host
      ) {
        return;
      }

      /*
        Restore original vertical position
        when sticky hides at footer.
      */

      if (
        whatsappState.originalBottom
      ) {
        whatsappState.host.style.setProperty(
          "bottom",
          whatsappState.originalBottom,
          whatsappState.originalBottomPriority
        );
      } else {
        whatsappState.host.style.removeProperty(
          "bottom"
        );
      }

      /*
        We intentionally KEEP the larger
        WhatsApp visual size requested.

        Only vertical position is restored.
      */

      whatsappState.host = null;
      whatsappState.icon = null;

      whatsappState.originalBottom = "";
      whatsappState.originalBottomPriority = "";

      whatsappState.baseBottom = null;

      whatsappState.originalScale = "";
      whatsappState.originalScalePriority = "";

      whatsappState.originalTransformOrigin = "";
      whatsappState.originalTransformOriginPriority = "";
    }

    /* =========================================
       SHOW / HIDE STICKY
       ========================================= */

    function showSticky() {
      if (isVisible) {
        return;
      }

      isVisible = true;

      updateStickyHeight();

      root.classList.add(
        "is-visible"
      );

      root.setAttribute(
        "aria-hidden",
        "false"
      );

      document.body.classList.add(
        "jpt-sticky-cart-visible"
      );

      resetBenefits();

      startBenefitRotation();

      /*
        Wait one animation frame so CSS
        has applied the visible sticky state.

        Then measure floating video position.
      */
      window.requestAnimationFrame(
        scheduleWhatsappPositioning
      );
    }

    function hideSticky() {
      if (!isVisible) {
        return;
      }

      isVisible = false;

      root.classList.remove(
        "is-visible"
      );

      root.setAttribute(
        "aria-hidden",
        "true"
      );

      document.body.classList.remove(
        "jpt-sticky-cart-visible"
      );

      stopBenefitRotation(true);

      restoreWhatsapp();
    }

    function syncSticky() {
      /*
        User-requested behavior:

        Sticky visible immediately
        from page load.

        Hide only when footer enters.
      */

      if (footerNear) {
        hideSticky();
      } else {
        showSticky();
      }
    }

    /* =========================================
       FOOTER OBSERVER
       ========================================= */

    var footer =
      document.querySelector(
        "footer"
      ) ||
      document.querySelector(
        '[class*="footer-group"]'
      );

    if (
      footer &&
      "IntersectionObserver" in window
    ) {
      footerObserver =
        new IntersectionObserver(
          function (entries) {
            var entry =
              entries[0];

            if (!entry) {
              return;
            }

            footerNear =
              entry.isIntersecting;

            syncSticky();
          },
          {
            threshold: 0,
            rootMargin: "0px"
          }
        );

      footerObserver.observe(
        footer
      );
    }

    /*
      IMPORTANT:
      show sticky immediately when
      product page opens.
    */
    syncSticky();

    /* =========================================
       ADD TO CART CLICK
       ========================================= */

    function handleStickyClick() {
      if (
        mainAddToCart.disabled ||
        mainAddToCart.getAttribute(
          "aria-disabled"
        ) === "true"
      ) {
        return;
      }

      /*
        Delegate to the actual Add to Cart
        button.

        Do NOT make another /cart/add.js
        request here.

        This preserves your existing
        cart drawer behavior.
      */
      mainAddToCart.click();
    }

    stickyButton.addEventListener(
      "click",
      handleStickyClick
    );

    /* =========================================
       TAB VISIBILITY
       ========================================= */

    function handleVisibilityChange() {
      if (
        document.hidden
      ) {
        stopBenefitRotation(
          false
        );

        return;
      }

      if (isVisible) {
        startBenefitRotation();

        window.requestAnimationFrame(
          positionWhatsapp
        );
      }
    }

    document.addEventListener(
      "visibilitychange",
      handleVisibilityChange
    );

    /* =========================================
       WINDOW RESIZE / ORIENTATION
       ========================================= */

    function handleWindowResize() {
      updateStickyHeight();

      if (isVisible) {
        window.requestAnimationFrame(
          positionWhatsapp
        );
      }
    }

    window.addEventListener(
      "resize",
      handleWindowResize,
      {
        passive: true
      }
    );

    updateStickyHeight();

    /* =========================================
       SHOPIFY THEME EDITOR CLEANUP
       ========================================= */

    root.jptStickyCleanup =
      function () {
        clearWhatsappRetryTimers();

        stopBenefitRotation(
          false
        );

        if (
          benefitTransitionTimer
        ) {
          window.clearTimeout(
            benefitTransitionTimer
          );

          benefitTransitionTimer =
            null;
        }

        if (
          resizeObserver
        ) {
          resizeObserver.disconnect();
        }

        if (
          footerObserver
        ) {
          footerObserver.disconnect();
        }

        stickyButton.removeEventListener(
          "click",
          handleStickyClick
        );

        document.removeEventListener(
          "visibilitychange",
          handleVisibilityChange
        );

        window.removeEventListener(
          "resize",
          handleWindowResize
        );

        restoreWhatsapp();

        document.body.classList.remove(
          "jpt-sticky-cart-visible"
        );

        delete root.dataset
          .jptStickyInitialized;

        delete root
          .jptStickyCleanup;
      };
  }

  /* =========================================
     INITIALIZE
     ========================================= */

  function initAllStickyCarts(scope) {
    var container =
      scope || document;

    var roots = [];

    if (
      container.matches &&
      container.matches(
        ROOT_SELECTOR
      )
    ) {
      roots.push(container);
    }

    if (
      container.querySelectorAll
    ) {
      Array.prototype.push.apply(
        roots,
        container.querySelectorAll(
          ROOT_SELECTOR
        )
      );
    }

    roots.forEach(
      initStickyCart
    );
  }

  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      function () {
        initAllStickyCarts(
          document
        );
      }
    );
  } else {
    initAllStickyCarts(
      document
    );
  }

  /* =========================================
     SHOPIFY SECTION LOAD
     ========================================= */

  document.addEventListener(
    "shopify:section:load",
    function (event) {
      initAllStickyCarts(
        event.target
      );
    }
  );

  /* =========================================
     SHOPIFY SECTION UNLOAD
     ========================================= */

  document.addEventListener(
    "shopify:section:unload",
    function (event) {
      var target =
        event.target;

      if (!target) {
        return;
      }

      if (
        target.matches &&
        target.matches(
          ROOT_SELECTOR
        ) &&
        typeof target.jptStickyCleanup ===
          "function"
      ) {
        target.jptStickyCleanup();
      }

      if (
        target.querySelectorAll
      ) {
        target
          .querySelectorAll(
            ROOT_SELECTOR
          )
          .forEach(
            function (root) {
              if (
                typeof root.jptStickyCleanup ===
                "function"
              ) {
                root.jptStickyCleanup();
              }
            }
          );
      }
    }
  );
})();